<div class="row margin-0">
  <!-- [class.sticky-nav]="landingsidesticky1" #landingside1 -->
  <div class="col-md-12 padding-left-0 padding-right-0 margin-bottom-5 landing-nav-sticky" >
    <div class="hpanel gs-cardgs-card">
      <div class="navMain panel-body border-radius-top-left-right-6">
        <div class="navIteam1">
          <!-- <label for="">Community</label> -->
          <h4>Community   :  <span> {{communityDetails?.length}}</span></h4>
        </div>
        <div class="navIteam2" style="margin-left: -185px;">
          <div class="input-group f-l">
            <!-- <input type="text" class="form-control input-sm" placeholder="Search Community"
              aria-label="Amount (to the nearest dollar)"  (keyup)="keyupdata($event)" (keyup.enter)="onsearch(CommSearch)" name="searchadmin" id="searchadmin" [(ngModel)]="CommSearch" />
              <span class="input-group-addon"  (click)="onsearch(CommSearch)" id="my_btn" ><ng-icon name="tablerSearch"></ng-icon></span> -->

              <input type="text" class="form-control input-sm" placeholder="Search Community"
              aria-label="Amount (to the nearest dollar)" name="searchadmin" id="searchadmin" [(ngModel)]="searchKey" />
              <span class="dummyBtn"></span>
                  </div>
        </div>
        <!-- <div class="navIteam3">
          <button class="btn btn-default " (click)="routePage()"> Create Community</button>
        </div> -->
        <!-- <div class="navIteam">
          <div class="btn-group" dropdown>
             <button type="button" class="btn primary-btn   " (click)="onsearch('')">{{btnnameshow }}</button>
            <button  id="button-animated" dropdownToggle   type="button" class="btn primary-btn    leftview  dropdown-toggle"
              dropdownToggle data-toggle="dropdown">
              <span><ng-icon name="tablerFilter"></ng-icon></span>
            </button>
              <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu"
                role="menu" aria-labelledby="button-animated">
                <li role="menuitem"><a class="dropdown-item" (click)="sort_by_key('all')">All  </a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="sort_by_key('admin')">Admin</a></li>
                <li role="menuitem"><a class="dropdown-item" (click)="sort_by_key('superadmin')">SuperAdmin</a></li>
             </ul>
          </div>
        </div> -->
      </div>
    </div>
  </div>
    <div class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0" *ngIf="communityDetails?.length==0" >
      <app-nodata-found [title]="noDatafound" ></app-nodata-found>
   </div>
    <div class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0"  *ngIf="loadAPIcall">
         <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
         >
          <app-common-skeleton [NameOftheScreen]="'usercard'"></app-common-skeleton>
        </div>
    </div>


    <div class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0"  *ngIf="communityDetails?.length > 0 && !loadAPIcall">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px!important;" *ngFor="let item of communityDetails | customFilter:{communityName:searchKey}:false">
        <app-community-card [data]="item"></app-community-card>
      </div>
  </div>


    <div class="col-sm-25 col-md-25 col-lg-25  padding-left-0 padding-right-0 landing-sticky-widget">
      <div class="" >
        <app-common-widget [page]="'COMMUNITY_LANDING_HOME_PAGE'" [inputData]="'HOME'"  [hideCompelte]="'LandingCommunity'" [userType]=userType></app-common-widget>
       </div>
    </div>
  </div>
